import { useNavigate, useParams } from "react-router";
import { EncoreFans } from "../encoreFans";
import { Kanban } from "../kanban";
import { AdminPanel } from "../adminPanel";
import { useEffect } from "react";
import { NestedApp } from "../nestedApp";
import { slugify } from "../../helpers";
import { Link } from "react-router-dom";
import { Fleet } from "../Fleet";
import { IoChevronBackSharp } from "react-icons/io5";
import { Bquiz } from "../bquiz";
import { Elevate } from "../elevate";

export const Project = () => {
  const { name } = useParams();
  const navigate = useNavigate();

  const Callback = () => {
    useEffect(() => navigate("/projects"), []);
    return null;
  };

  const projects = [
    {
      text: "BQuiz - AI-Powered Quiz Creation Platform",
      comp: <Bquiz />,
    },
    {
      text: "Elevate Health - Admin & Patient Portal",
      comp: <Elevate />,
    },
    {
      text: "FMS - Fleet Tracking & Management Platform",
      comp: <Fleet />,
    },
    {
      text: "PL Admin Panel - Role Based Administrative Access",
      comp: <AdminPanel />,
    },
    {
      text: "Encore - Multi-Programs Fans Application",
      comp: <EncoreFans />,
    },
    {
      text: "Kanban - Project Management Board",
      comp: <Kanban />,
    },
    {
      text: "Comment Cascade - Infinite Comment Nesting",
      comp: <NestedApp />,
    },
  ];

  const renderComp = projects?.find((p) => slugify(p?.text) === name)?.comp;
  const title = projects?.find((p) => slugify(p?.text) === name)?.text;

  return (
    <div className="sm:pt-24 py-20">
      <Link
        to={"/projects"}
        className="flex justify-center text-sm bg-secondary border-tag items-center rounded-full border gap-x-2 max-w-20 mx-5 sm:mx-28 py-1"
      >
        <IoChevronBackSharp size={12} className="text-primary" />
        <span className="text-header">back</span>
      </Link>
      <div className="px-5 sm:px-28">
        <div className="sm:text-[35px] text-[30px] text-center font-[600] mt-3 text-primary w-full">
          {title}
        </div>
        <div className="">{renderComp ? renderComp : <Callback />}</div>
      </div>
    </div>
  );
};
